var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c(`${_vm.capitalizeFirstLetter(_vm.locale)}FooterContent`,{tag:"component"}),_vm._v(" "),_c('privacy-policy-modal'),_vm._v(" "),_c('terms-and-conditions-modal'),_vm._v(" "),_c('content-licence-agreement-modal'),_vm._v(" "),_c('contact-modal'),_vm._v(" "),_c('announcement-modal'),_vm._v(" "),_c('add-to-collection-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }